module.exports = __webpack_public_path__ + "static/best-in-brighton-landscape-252b30f6729f3ad9b997413f49a15520.png";